// extracted by mini-css-extract-plugin
export default {"showTable":"show_showTable__8+qg0","pageHeading":"show_pageHeading__0-lOL"};